import { render, staticRenderFns } from "./CicekSepeti.vue?vue&type=template&id=5b2710c6&scoped=true"
import script from "./CicekSepeti.vue?vue&type=script&lang=js"
export * from "./CicekSepeti.vue?vue&type=script&lang=js"
import style0 from "./CicekSepeti.vue?vue&type=style&index=0&id=5b2710c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2710c6",
  null
  
)

export default component.exports